module.exports = __webpack_public_path__ + "07745f77da5725ce21df0ff73ba84a9a.png";